import React, { FC, useContext } from "react";
import {
  CompraSegura,
  HelpContainer,
  HelpLink,
  HelpText,
  IuguProcess,
  NeedHelp,
  RodapeContainer,
} from "./Rodape.styles";
import CompraSeguraImg from "./../../../Static/Images/compra_segura.png";
import { isBrowser, isMobile } from "react-device-detect";
import { TermoContext } from "../../../Context/Termos/Termo.Provider";
export interface IRodape {
  showNeedHelp: boolean;
}

const Rodape: FC<IRodape> = ({ showNeedHelp }) => {
  const termoContext = useContext(TermoContext);

  return (
    <RodapeContainer>
      <CompraSegura>
        <img alt="Compra Segura" src={CompraSeguraImg} />
      </CompraSegura>
      {showNeedHelp && (
        <HelpContainer>
          <NeedHelp>
            <HelpText>Precisa de ajuda? &nbsp;</HelpText>
            <HelpLink href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL}`}>
              Entre em contato
            </HelpLink>
          </NeedHelp>
          <HelpLink href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL}`}>
            Preciso de ajuda para preencher esta tela
          </HelpLink>
        </HelpContainer>
      )}
      <IuguProcess>
        {showNeedHelp && (
          <>
            <NeedHelp>
              <HelpText>
                A Iugu está processando este pedido a serviço de Lorena Damásio
                Cardoso, ao continuar, você concorda com os&nbsp;
              </HelpText>
              {isBrowser && (
                <HelpLink
                  onClick={() =>
                    termoContext.effects &&
                    termoContext.effects.getTermo("termos-de-uso-vet-saude")
                  }
                >
                  Termos de Compra
                </HelpLink>
              )}
            </NeedHelp>
            {isMobile && (
              <HelpLink
                onClick={() =>
                  termoContext.effects &&
                  termoContext.effects.getTermo("termos-de-uso-vet-saude")
                }
              >
                Termos de Compra
              </HelpLink>
            )}
          </>
        )}
        <HelpText>
          O Vet Saúde é um produto da QueroVet - 32.774.516/0001-80
        </HelpText>
      </IuguProcess>
    </RodapeContainer>
  );
};

export default Rodape;
